:host(.tooltip-open) .default-icon {
  color: var(--theme-dark-text);
}

.default-icon {
  color: var(--theme-tertiary-text);
}
